export enum Permission {
  StoreConfigsView = 'store_configs.view',
  StoreConfigsModify = 'store_configs.modify',
}
